import { AxiosPromise } from 'axios';
import {
  CreateNewPasswordType,
  LoginResponse,
  LoginTypes,
  ResetPasswordTypes,
  SignUpTypes,
  MfaCodeResendType,
  MfaCodeVerifyType,
} from 'interfaces';
import { api } from './api';

export class AuthAPI {
  static checkAuth(): AxiosPromise {
    return api.get('/me');
  }

  static login(payload: LoginTypes): AxiosPromise<LoginResponse> {
    return api.post('/login_check', payload);
  }

  static signUp(payload: SignUpTypes): AxiosPromise {
    return api.post('/users/register.jsonld', payload);
  }

  static forgotPassword(email: string): AxiosPromise {
    return api.get(`/users/${email}/reset-password.jsonld`);
  }

  static resetPassword(payload: ResetPasswordTypes): AxiosPromise {
    return api.put('/users/reset-password.jsonld', payload);
  }

  static createNewPassword(payload: CreateNewPasswordType): AxiosPromise {
    return api.post('/users/create-password', payload);
  }

  static checkSsoAzureConfig(): AxiosPromise {
    return api.get('/config/sso-azure/check');
  }

  static checkSsoJwtConfig(): AxiosPromise {
    return api.get('/config/sso-jwt/check');
  }

  static checkSsoSamlConfig(): AxiosPromise {
    return api.get('/config/sso-saml/check');
  }

  static checkPasswordResetToken(token: string) {
    return api.get(`users/${token}/check-reset-password-token`);
  }

  static verify2fa(payload: MfaCodeVerifyType): AxiosPromise {
    return api.post('/2fa/verify', payload);
  }

  static resend2fa(payload: MfaCodeResendType): AxiosPromise {
    return api.post('/2fa/resend', payload);
  }
}
